import React, {ReactNode} from 'react'
import {Box, SxProps, Theme} from '@mui/material'
import {APP_BACKGROUND, CARD_BORDER_COLOR, CARD_BORDER_RADIUS} from 'src/theme-new/tokens'

interface AuthLayoutProps {
  logo?: ReactNode
  children: ReactNode
  footer?: ReactNode
  maxWidth?: number
  sx?: SxProps<Theme>
}

export default function AuthLayout({logo, children, footer, maxWidth = 440, sx}: AuthLayoutProps): JSX.Element {
  return (
    <Box sx={{
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: {xs: '#fff', sm: APP_BACKGROUND},
      padding: {xs: 0, sm: 4},
    }}>
      <Box sx={{
        width: '100%',
        maxWidth: {xs: 'none', sm: maxWidth},
        minHeight: {xs: '100vh', sm: 'auto'},
        backgroundColor: '#fff',
        borderRadius: {xs: 0, sm: CARD_BORDER_RADIUS},
        border: {xs: 'none', sm: `1px solid ${CARD_BORDER_COLOR}`},
        boxShadow: {xs: 'none', sm: '0px 4px 12px rgba(0,0,0,0.04)'},
        padding: {xs: 3, sm: 5},
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        justifyContent: {xs: 'center', sm: 'flex-start'},
        ...sx,
      }}>
        {logo && (
          <Box sx={{display: 'flex', justifyContent: 'center'}}>
            {logo}
          </Box>
        )}
        <Box>{children}</Box>
        {footer && (
          <Box sx={{borderTop: `1px solid ${CARD_BORDER_COLOR}`, pt: 2}}>
            {footer}
          </Box>
        )}
      </Box>
    </Box>
  )
}
